<payee-popup>
  <ng-template #payeePopupTitleTemplate>
    <payee-icon
      name="trash-black"
      class="title-icon"
      height="73px"
      width="auto"
    ></payee-icon>
    <h1>{{ "WORKFLOW_DIALOGS.DISCARD_CASE.TITLE" | translate }}</h1>
  </ng-template>

  <ng-template #payeePopupDescriptionTemplate>
    <div class="description">
      {{ "WORKFLOW_DIALOGS.DISCARD_CASE.DESCRIPTION" | translate }}
    </div>
  </ng-template>

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      color="alert-red"
      width="max"
      height="normal"
      data-testid="discard-case-confirm"
      [mat-dialog-close]="true"
    >
      {{ "WORKFLOW_DIALOGS.DISCARD_CASE.CONFIRM" | translate }}
    </button>
  </ng-template>

  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      color="white"
      width="max"
      height="normal"
      [isBorderButton]="true"
      [mat-dialog-close]="false"
    >
      {{ "WORKFLOW_DIALOGS.DISCARD_CASE.CANCEL" | translate }}
    </button>
  </ng-template>
</payee-popup>
